/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['./urlBuilder', './errorHandlerFetch', './analytics', 'services/utils'],
    function(urlBuilder, errorHandler, analytics, Utils) {
        'use strict';

        function stringify(obj) {
            try {
                return JSON.stringify(obj);
            } catch (ex) {
                return null;
            }
        }

        function setHeader(requestOptions, headerName, headerValue) {
            var header;
            if (!requestOptions.headers) {
                requestOptions.headers = {};
            }

            header = requestOptions.headers[headerName] || requestOptions.headers[headerName.toLowerCase()];
            if (!header) {
                requestOptions.headers[headerName] = headerValue;
            }
        }

        function addObjectBodyParams(bodyParams, requestOptions) {
            var body;
            if (!(bodyParams instanceof FormData) && !(bodyParams instanceof Blob)) {
                body = stringify(bodyParams);
                if (!body) {
                    throw new Error('Unsupported request body type: ' + bodyParams);
                }
                setHeader(requestOptions, 'Content-Type', 'application/json');
            } else {
                body = bodyParams;
            }
            return body;
        }

        function addBodyParams(options, requestOptions) {
            var bodyParams = options.bodyParameters, body;
            if (!bodyParams) {
                return;
            }

            if (Utils.isObject(bodyParams)) {
                body = addObjectBodyParams(bodyParams, requestOptions);
            } else if (Utils.isString(bodyParams)) {
                body = bodyParams;
            }

            requestOptions.body = body;
        }

        function performFetchRequest(options, url, requestOptions) {
            fetch(url, requestOptions)
                .then(function(response) {
                    if (response.ok) {
                        if (options.requestType === 'batch' && response.status === 202) {
                            return options.callback(response.headers.get('Location'));
                        }
                        return response.json().then(options.callback);
                    } else {
                        return Promise.reject(response);
                    }
                })
                .catch(function(reason) {
                    errorHandler(options, reason);
                });
        }

        return {
            /**
             * Executes a request and processes the response as JSON.
             * @method get
             * @param {Object} options Specifies the details of the request.
             * @param {String} options.url The URL to request.
             * @param {Object} [options.queryParameters] The data to pass as GET parameters with the request.
             * @param {Object} [options.pathParameters] The data to use as {placeholders} in url.
             * @param {Function} [options.fail] The callback to execute when the request fails.
             * @param {Function} options.callback The callback to execute when the request completes.
             */
            get: function(options) {
                var url, requestOptions, headers = {};
                options.pathParameters = options.pathParameters || {};
                options.pathParameters.contentType = 'json';
                options.pathParameters.protocol = options.pathParameters.protocol || 'https';

                url = urlBuilder(options.url, options.pathParameters, options.queryParameters);
                if (analytics.isTomtomOrigin(url)) {
                    headers = analytics.getAnalyticsHeader();
                }
                headers['Accept'] = 'application/json'; //eslint-disable-line dot-notation

                requestOptions = {
                    method: 'GET',
                    headers: headers,
                    mode: 'cors'
                };

                performFetchRequest(options, url, requestOptions);
            },

            /**
             * Executes a request and processes the response as JSON.
             * @method post
             * @param {Object} options Specifies the details of the request.
             * @param {String} options.url The URL to request.
             * @param {Object} [options.queryParameters] The data to pass as Url parameters with the request.
             * @param {Object} [options.pathParameters] The data to use as {placeholders} in url.
             * @param {Object} [options.bodyParameters] The data to pass to request body.
             * @param {Function} [options.fail] The callback to execute when the request fails.
             * @param {Function} options.callback The callback to execute when the request completes.
             */
            post: function(options) {
                var url, requestOptions, headers = {};
                options.pathParameters = options.pathParameters || {};
                options.pathParameters.contentType = 'json';
                options.pathParameters.protocol = options.pathParameters.protocol || 'https';

                url = urlBuilder(options.url, options.pathParameters, options.queryParameters);
                if (analytics.isTomtomOrigin(url)) {
                    headers = analytics.getAnalyticsHeader();
                }
                headers['Accept'] = 'application/json'; //eslint-disable-line dot-notation

                requestOptions = {
                    method: 'POST',
                    headers: headers,
                    mode: 'cors',
                    redirect: 'follow'
                };

                addBodyParams(options, requestOptions);
                performFetchRequest(options, url, requestOptions);
            }
        };
    });



// WEBPACK FOOTER //
// ./requester/json.js